// Custom Blog Slider js
$(document).ready(function(){
  $('.custom-blog-slider').slick({
    slidesToShow: 2.2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: 'linear',
    infinite: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
  });
});

// Custom Info Graphic Slider js
$(document).ready(function(){
  $('.info-graphic-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    dots: true,
    autoplaySpeed: 3000,
    cssEase: 'linear',
    infinite: true,
  });
});

// Custom Reviews Slider js
$(document).ready(function(){
  $('.custom-review-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    cssEase: 'linear',
    infinite: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});

// Custom reviews Slider in product info js
$(document).ready(function(){
  $('.featured_reviews').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay:false,
    dots: true,
    arrows: false
  });
});


// Product TAbs

      const tabs = document.querySelectorAll('[data-tab-target]')
  const tabContents = document.querySelectorAll('[data-tab-content]')

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = document.querySelector(tab.dataset.tabTarget)
      tabContents.forEach(tabContent => {
        tabContent.classList.remove('active')
      })
      tabs.forEach(tab => {
        tab.classList.remove('active')
      })
      tab.classList.add('active')
      target.classList.add('active')
    })
  })

